import { auth_client, client } from '../index';
import calendar from './calendar';
import users from './users';

const self = { calendar, users }

export default self;
